import { render, staticRenderFns } from "./settlement-detail.vue?vue&type=template&id=0fe511b0&scoped=true&"
import script from "./settlement-detail.vue?vue&type=script&lang=js&"
export * from "./settlement-detail.vue?vue&type=script&lang=js&"
import style0 from "./settlement-detail.vue?vue&type=style&index=0&id=0fe511b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe511b0",
  null
  
)

export default component.exports